const CELL_PADDING_X = '12px';
const CELL_PADDING_Y = '12px';

const CELL_PADDING_X_LG = '24px';
const CELL_PADDING_Y_LG = '12px';

export const MAX_CELL_HEIGHT = '340px';
export const CELL_PADDING = (size: 'sm' | 'lg' = 'sm') => ({
  paddingLeft: size === 'sm' ? CELL_PADDING_X : CELL_PADDING_X_LG,
  paddingRight: size === 'sm' ? CELL_PADDING_X : CELL_PADDING_X_LG,
  paddingTop: size === 'sm' ? CELL_PADDING_Y : CELL_PADDING_Y_LG,
  paddingBottom: size === 'sm' ? CELL_PADDING_Y : CELL_PADDING_Y_LG,
});
